import { NgModule } from '@angular/core';
import { NgrxDialogOpenDirective } from './ngrx-dialog-open.directive';

@NgModule({
  declarations: [ NgrxDialogOpenDirective ],
  exports: [ NgrxDialogOpenDirective ]
})
export class NgrxDialogOpenModule {
}
